import React, { FC, useCallback } from 'react'
import { Helmet } from 'react-helmet'
import { cn } from '@bem-react/classname'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Memo } from '@/hoc/Memo'

import { Back } from '@/components/Back'
import { Block } from '@/components/Block'
import { Button } from '@/components/Button'
import { Title } from '@/components/Title'

const cnAddLicense = cn('AddLicense')

import './styles/AddLicense.scss'

export const AddLicense: FC = Memo(() => {
  const { t } = useTranslation('translation')
  const navigate = useNavigate()

  const addLicense = useCallback((type: number) => {
    navigate(`/cabinet/licenses/create?type=${type}`)
  }, [])

  return (
    <>
      <Helmet>
        <title>{t('Choosing the type of licence')} | Registration</title>
      </Helmet>
      <div className={cnAddLicense()}>
        <Back />
        <Title className={cnAddLicense('title')}>
          {t('Please choose a registration option')}
        </Title>

        <div className={cnAddLicense('wrap')}>
          <Block className={cnAddLicense('block')}>
            <div className={cnAddLicense('header')}>
              {t('Registration by Serial Device Number')}
            </div>
            <div className={cnAddLicense('text')}>
              {t(
                'Select this option if you have a DG scale (DG600, DG8000 or DG8000ic) and you want to try the DTM',
              )}
            </div>
            <img
              className={cnAddLicense('serial')}
              src='/img/number-serial.jpg'
              alt='serial number'
            ></img>
            <Button
              onClick={() => addLicense(1)}
              className={cnAddLicense('btn')}
            >
              {t('Select')}
            </Button>
          </Block>
          <Block className={cnAddLicense('block')}>
            <div className={cnAddLicense('header')}>
              {t('Registration by License Number')}
            </div>
            <div className={cnAddLicense('text')}>
              {t(
                'Select this option if you alredy have you DTM package and you want to activate your license',
              )}
            </div>
            <img
              className={cnAddLicense('license')}
              src='/img/number-license.jpg'
              alt='serial number'
            ></img>
            <Button
              onClick={() => addLicense(2)}
              className={cnAddLicense('btn')}
            >
              {t('Select')}
            </Button>
          </Block>
        </div>
      </div>
    </>
  )
})
